import ApiService from "../api";
import {encryptEmpfat} from '../EncriptService.js';

class FaturaService extends ApiService{

    constructor(){
        super('/portal/fatura')
    }

    listar(filtro){
        return this.post('/listarFaturas', encryptEmpfat(filtro))
    }

    detalhar(filtro){
        return this.post('/detalharFatura', encryptEmpfat(filtro))
    }
}

export default FaturaService;